'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canSendNewOfficeHoursMessage = undefined;

var _hasBotMessages = require('conversations-schema/thread-history/operators/hasBotMessages');

var _hasOfficeHoursMessageFromCurrentSession = require('./hasOfficeHoursMessageFromCurrentSession');

var _enoughTimeHasPassedForNewAutomatedChatMessage = require('./enoughTimeHasPassedForNewAutomatedChatMessage');

var canSendNewOfficeHoursMessage = exports.canSendNewOfficeHoursMessage = function canSendNewOfficeHoursMessage(threadHistory) {
  return !(0, _hasBotMessages.hasBotMessages)(threadHistory) && (!(0, _hasOfficeHoursMessageFromCurrentSession.hasOfficeHoursMessageFromCurrentSession)(threadHistory) || (0, _enoughTimeHasPassedForNewAutomatedChatMessage.enoughTimeHasPassedForNewAutomatedChatMessage)(threadHistory));
};